import styled from 'styled-components';

import { MOBILE_ANIM } from '../../mobile.tokens';

/**
 * Static screenshot filling the inline phone screen. Fills the SAME box the live
 * `PreviewFrame` iframe used to (full-bleed, non-interactive), fading in on load —
 * so the mobile design flow shows the configured site without keeping a heavy live
 * casino SPA warm inline (which froze RAM-constrained phones). `cover` + top anchor
 * reproduces the iframe's own framing (the site's top fills the width, the overflow
 * below the fold is clipped) with no distortion or letterbox.
 */
export const PreviewImg = styled.img<{ $shown: boolean }>`
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: top center;
  pointer-events: none;
  user-select: none;
  opacity: ${({ $shown }) => ($shown ? 1 : 0)};
  transition: opacity ${MOBILE_ANIM.previewFadeMs}ms ease;
`;
